export const AgoHours = "{0}h ago";
export const AgoMinutes = "{0}m ago";
export const Collapsed = "Collapsed";
export const DayAtTimeFormat = "{0} at {1}";
export const DaysHoursMinutes = "{0}d {1}h {2}m";
export const Expanded = "Expanded";
export const FriendlyNumberBillionsFormat = "{0}B+";
export const FriendlyNumberMillionsFormat = "{0}M+";
export const FriendlyNumberThousandsFormat = "{0}K+";
export const HoursMinutesSeconds = "{0}h {1}m {2}s";
export const JustNow = "Just now";
export const LessThanASecond = "<1s";
export const MinutesSeconds = "{0}m {1}s";
export const Seconds = "{0}s";
export const Today = "Today";
export const Yesterday = "Yesterday";
